class AccordionGroup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleScrollTrigger = this.handleScrollTrigger.bind(this)

    this.els.trigger.elements.forEach((triggerEl) => {
      this.listeners.add(triggerEl, `click`, this.handleTrigger)
    })

    if (this.externalEls?.['scroll-trigger']?.exists) {
      this.externalEls['scroll-trigger'].elements.forEach((scrollTriggerEl) => {
        this.listeners.add(scrollTriggerEl, 'click', this.handleScrollTrigger)
      })
    }
  }

  handleTrigger (event) {
    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    if (this.dataset.type === 'oneopen') {
      this.els?.item?.elements.forEach((tempEl) => {
        if (tempEl !== itemEl) {
          tempEl.setAttribute('aria-expanded', 'false')
        }
      })
    }

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }

  handleScrollTrigger (event) {
    const trigger = event.currentTarget
    const tab = trigger.dataset.tab

    if (!tab) return

    const itemEl = this.els?.item?.elements.find(
      (el) => el.dataset.tab === tab,
    )
    if (!itemEl) return

    itemEl.scrollIntoView({ behavior: 'smooth', block: 'start' })

    if (itemEl.getAttribute('aria-expanded') !== 'true') {
      itemEl.setAttribute('aria-expanded', 'true')
    }
  }
}

if (!customElements.get('accordion-group')) {
  customElements.define('accordion-group', AccordionGroup)
}
